module.exports = __webpack_public_path__ + "static/header-intern-69a0befad7dbd5298a46dca8e957ae54.jpg";